import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function TrendingSection() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <span className="px-2.5 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
              HOT
            </span>
          </div>
          <Link
            to="/category/dianshiju"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer"
          >
            更多热门
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/detail/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-md">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute bottom-2 left-2 right-2">
                  <p className="text-xs text-background-50/90 truncate">{video.updateInfo}</p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">
                {video.year} / {video.region}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}